import { autoBeforeEachTest } from '@atlassian/jira-platform-auto-before-each-test/src/auto-before-each-test.tsx';

let ssrFailedMarker = false;
let failedMarkers = new Set<string>();
let isTrackingEnabled = true;

autoBeforeEachTest(() => {
	ssrFailedMarker = false;
	failedMarkers = new Set();
	isTrackingEnabled = true;
});

/**
 * @internal only for local usage by rendering guard
 */
export const markSSRFailure = (fallbackId: string | undefined): void => {
	if (!isTrackingEnabled) return;

	ssrFailedMarker = true;
	if (fallbackId != null) {
		failedMarkers.add(fallbackId);
	}
};

/**
 * reports if SSR failure was reported via ReportSSRFailOnUse
 */
export const hasFailedSSR = () => ssrFailedMarker;
export const getFailedMarkers = () => failedMarkers;

export const getIsTrackingEnabled = () => isTrackingEnabled;

/** @deprecated to be called only during SSR's prewarm phase */
export async function runWithTrackingDisabled(cb: () => Promise<void>): Promise<void> {
	try {
		isTrackingEnabled = false;
		await cb();
	} finally {
		isTrackingEnabled = true;
	}
}
